import exame from './exame'
import laboratorio from './laboratorio'

export default [
    ...exame,
    ...laboratorio,
]